import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconGlass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGlass"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12.5 5.51894C12.335 5.50639 12.1682 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 12.1682 5.50639 12.335 5.51894 12.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconGlass;
